<template>
  <el-dialog title="故障原因" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: 0px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <!-- <div class="grid-height" style="display:flex"> -->

        <div class="table_main" style="height: 400px!important;">
          <vxe-grid ref="table-m1" height="390"
                    v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle"
                    @checkbox-change="addDataTable"
                    @checkbox-all="checkAll"
                    @cell-dblclick="checkWithSubmit"
          >

            <template #form>

              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                        :data="formData" @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="原因编码:" field="itemName">
                  <template v-slot>
                    <el-input v-model="searchReasonCode" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="原因名称:" field="itemName">
                  <template v-slot>
                    <el-input v-model="searchReasonName" size="small" clearable/>
                  </template>
                </vxe-form-item>
              </vxe-form>
              <div class="clearfix screen-btns">
                <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--                              status="primary" plain>重置-->
                  <!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
        <!-- </div> -->
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.reasonName }}</p>
          <a class="el-icon-close" @click="clearTable1Select(index)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'symptomId', 'excludeIdList', 'bigCategoryId', 'smallCategoryId'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.initSetting();
    if (this.excludeIdList) {
      this.formData.excludeIdList = this.excludeIdList
    }
    if (this.bigCategoryId) {
      this.formData.bigCategoryId = this.bigCategoryId
    }
    if (this.smallCategoryId) {
      this.formData.smallCategoryId = this.smallCategoryId
    }
    if (this.symptomId) {
      this.formData.symptomId = this.symptomId
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      data: [],
      checkedArray: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        reasonCode: '',  // 故障原因编码
        reasonName: null,
        excludeIdList: null,
        bigCategoryId: null,
        smallCategoryId: null,
      },
      getTableDataUrl: '/basic/basFaultReason/getListPage',
      bindDataUrl: '/basic/basFaultReasonMapping/add',
      bindRelieveDataUrl: '/basic/basFaultReasonMapping/delete',
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchReasonCode: '',
      searchReasonName: null,
      selectedRow: {
        id: '', name: ''
      },
      columns: [
        {type: "checkbox", width: 40, fixed: 'left'},
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '故障原因编码', field: 'reasonCode', width: 150,},
        {title: '故障原因名称', field: 'reasonName', width: 150,},
        {title: '产品大类', field: 'bigCategoryName', width: 150,},
        {title: '产品小类', field: 'smallCategoryName', width: 150,},
        {
          title: '启用', field: 'usable', width: 150, slots: {
            default: ({row}) => {
              if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        {field: 'createTime', title: '创建时间', width: 150},
        {title: '创建人', field: 'createBy', width: 150,},
      ]
    };
  },


  methods: {
    flushed() {
      this.checkedArray = []
      this.$refs['table-m1'].commitProxy('reload');
    },


    // commitRow() {
    //   if (this.checkedArray.length === 0) {
    //     this.$message.warning('请先选中故障原因')
    //   } else {
    //     this.$http({
    //       url: this.bindDataUrl,
    //       method: 'post',
    //       data: {
    //         symptomId: this.symptomId,
    //         reasonIds: this.checkedArray
    //       }
    //     }).then(res => {
    //       this.$message.success("添加成功")
    //       this.flushed()
    //     })
    //   }
    // },

    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList()
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.formData.reasonCode = this.searchReasonCode
      this.formData.reasonName = this.searchReasonName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // // 重置
    // resetEvent() {
    //   this.searchReasonCode = ''
    //   this.formData.reasonCode = ''
    //   this.formData.current = 1
    //   this.formData.searchCount = false
    //   this.formData.bigCategoryId = ''
    //   this.formData.smallCategoryId = ''
    //   this.$refs.pager.reset()  // 重置分页器
    //   this.flushed()
    // },

    // checkboxChange(checked) {
    //   console.log(checked)
    //   if (checked.checked) {
    //     this.checkedArray.push(checked.row.id)
    //   } else {
    //     // this.checkedArray.splice(this.checkedArray.indexOf(checked.row.id), 1)
    //     this.checkedArray = this.checkedArray.filter(item => item !== checked.row.id)
    //   }
    //   console.log(this.checkedArray)
    // },

    // checkAll(checkedAll) {
    //   console.log(checkedAll)
    //   if (checkedAll.checked) {
    //     this.checkedArray = []
    //     checkedAll.records.forEach(item => {
    //       this.checkedArray.push(item.id)
    //     })
    //   } else {
    //     this.checkedArray = []
    //   }
    //   console.log(this.checkedArray)
    // },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: this.getTableDataUrl,
        param: this.formData,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption)
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
::v-deep #containt {
  background-color: #fff;
  margin: 10px;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, .04);
  box-shadow: 0 2px 6px rgba(0, 0, 0, .04);
  margin-top: 0;
  padding-bottom: 10px !important;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}

::v-deep .el-dialog {

  margin-top: 134px !important;

}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
